let token = null;
export const setXsrf = (t) => { token = t || null; };
export const getXsrf = () => token;
